import { render, staticRenderFns } from "./TenantAdminTab.vue?vue&type=template&id=12401ab4"
import script from "./TenantAdminTab.vue?vue&type=script&lang=ts"
export * from "./TenantAdminTab.vue?vue&type=script&lang=ts"
import style0 from "./TenantAdminTab.vue?vue&type=style&index=0&id=12401ab4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports